import React, { useEffect, useState } from 'react'
import SideBar from '../SideBar.js'
import Header from '../../Header/Header.js'
import BillingHeader from './BillingHeader.js'
import Table from "../../components/Table/index.jsx";
import { useQuery } from "@apollo/client";
import { GET_COD_REMITTANCE_SUMMERY, GET_CUSTOMER_PAYMENT_TRANSACTION } from '../../graphql/Query/SellerTransaction.js';
import moment from 'moment';
import * as XLSX from "xlsx";
import { FiDownload } from 'react-icons/fi';

const CodRemittances = () => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [orderData, setOrderData] = useState([]);

    const { data: GetOrderOrderData, loading } = useQuery(GET_CUSTOMER_PAYMENT_TRANSACTION, {
        variables: {
            page: page,
            limit: limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },

        },
        fetchPolicy: "cache-and-network"
    })
    const { data: codRemmitance } = useQuery(GET_COD_REMITTANCE_SUMMERY, {
        fetchPolicy: "cache-and-network"
    })
    // console.log('✌️codRemmitance --->', codRemmitance);
    useEffect(() => {
        if (GetOrderOrderData?.getPaymentTransactionForCustomer?.data) {
            setOrderData(GetOrderOrderData?.getPaymentTransactionForCustomer?.data);
        }
    }, [GetOrderOrderData]);

    const downloadExcel = (data) => {
        if (!data || data?.length === 0) {
            alert("No data available for download");
            return;
        }

        // Define the headers and extract the required data fields
        const formattedData = data.flatMap((row) =>
            row?.orderIds.map((order, index) => ({
                "ID": index + 1,
                "Shipment Date": order?.createdAt ? moment(order?.createdAt).format("DD MMM YY") : "",
                "Order ID": order?.order_id,
                "Order No": order?.order_number,
                "Weight": ` ${order?.package_weight} K.G`,
                "AWB": order?.awb_number,
                "Collectable Amount": order?.codCollectableValue,
                "Order Amount": order?.codCollectableValue,
                "Delivery Date": order?.delivery_order_Date ? moment(order?.delivery_order_Date).format("DD MMM YY") : "",
            }))
        );

        // Convert data to a worksheet
        const ws = XLSX.utils.json_to_sheet(formattedData);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Payment Transactions");

        // Download the Excel file
        XLSX.writeFile(wb, `Remittance.xlsx`);
    };

    const columns = [
        {
            name: '#',
            selector: (row, index) => (
                <span className="text-xs">
                    {index + 1 + ((page - 1) * limit)}
                </span>
            ),
            sortable: true,
            width: "80px",
        },
        {
            name: 'Remittance ID',
            selector: (row) => (
                <span className="text-xs">
                    {row?.remittance_id ? row?.remittance_id : "-"}
                </span>
            ),
            sortable: true,
        },
        {
            name: 'COD Amount',
            selector: (row) => (
                <span className="text-xs">
                    {row?.paymentAmount ? `₹${row?.paymentAmount}` : 0
                    }
                </span >
            ),
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row?.cod_payment_status,
            sortable: true,
            cell: (row) => (
                <span className="text-xs">
                    {row?.cod_payment_status === "success" ? "Paid" : row?.cod_payment_status}
                </span>
            ),
        },
        {
            name: 'Payment Date',
            selector: (row) => (
                <span className="text-xs">
                    {
                        row?.createdAt ? moment(row.createdAt).format("MMM DD, YYYY hh:mm A") : "-"}
                </span>
            ),
            sortable: true,
            width: "180px"
        },
        {
            name: 'Freight Deductions',
            selector: (row) => (
                <span className="text-xs">
                    {row?.fright_deduction ? `₹${row?.fright_deduction}` : '₹0'
                    }
                </span >
            ),
            sortable: true,
        },
        {
            name: 'Remittance Amount',
            selector: (row) => (
                <span className="text-xs">
                    {row?.remittance_amount ? `₹${row?.remittance_amount}` : 0
                    }
                </span >
            ),
            sortable: true,
        },
        {
            name: 'Volume',
            selector: (row) => (
                <span className="text-xs">
                    {row?.totalShipment ? `${row?.totalShipment}` : "-"
                    }
                </span >
            ),
            sortable: true,
        },
        {
            name: 'Payment Ref',
            selector: (row) =>
            (
                <span className="text-xs">
                    {row?.createdAt ? moment(row.createdAt).format("MMM DD, YYYY hh:mm A") : "-"
                    }
                </span >
            ),
            sortable: true,
            width: "180px"
        },
        {
            name: 'Download',
            cell: (row) => (
                <button onClick={() => downloadExcel([row])} className="flex items-center gap-2 text-xs px-3 py-1 text-[#5C74FB] border border-[#5C74FB] rounded-md shadow-sm hover:shadow-md hover:bg-[#5C74FB] hover:text-white transition"
                >
                    <FiDownload size={14} />
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const handlePagination = (page) => {
        setPage(page?.selected);
    };

    return (
        <div>
            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden ml-16">
                {/* Sidebar */}
                <SideBar />
                <div className="flex-1 space-y-3  md:p-6 py-6 overflow-x-hidden">
                    <div>

                        <BillingHeader />
                        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            <div className="p-5 bg-white text-center transition-all duration-300">
                                <p className="text-gray-500 text-sm">Remitted Till Date</p>
                                <p className="text-2xl font-bold text-gray-900 mt-1">₹{codRemmitance?.getRemittanceSummary?.remittedTillDate ? Number(codRemmitance?.getRemittanceSummary?.remittedTillDate?.toFixed(2)) : 0}</p>
                            </div>


                            <div className="p-5 bg-white text-center transition-all duration-300">
                                <p className="text-gray-500 text-sm">Last Remittance</p>
                                <p className="text-2xl font-bold text-gray-900 mt-1">₹{codRemmitance?.getRemittanceSummary?.lastRemittance ? Number(codRemmitance?.getRemittanceSummary?.lastRemittance?.toFixed(2)) : 0}</p>
                            </div>


                            <div className="p-5 bg-white text-center transition-all duration-300">
                                <p className="text-gray-500 text-sm">Next Remittance (Expected)</p>
                                <p className="text-2xl font-bold text-gray-900 mt-1">₹{codRemmitance?.getRemittanceSummary?.nextRemittance ? Number(codRemmitance?.getRemittanceSummary?.nextRemittance?.toFixed(2)) : 0}</p>
                            </div>


                            <div className="p-5 bg-white text-center transition-all duration-300">
                                <p className="text-gray-500 text-sm">Total Remittance Due</p>
                                <p className="text-2xl font-bold text-gray-900 mt-1">₹{codRemmitance?.getRemittanceSummary?.totalRemittanceDue ? Number(codRemmitance?.getRemittanceSummary?.totalRemittanceDue?.toFixed(2)) : 0}</p>
                            </div>
                        </div>
                    </div>
                    {/* Main Content */}
                    <div className="mt-2 bg-white p-4 border rounded-lg">
                        <Table
                            columns={columns}
                            data={orderData}
                            currentPage={page}
                            totalRecords={GetOrderOrderData?.getPaymentTransactionForCustomer?.count || 0}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            loading={loading}
                            // deleteData={DeleteProduct}
                            // onSort={handleSort}
                            handlePagination={handlePagination}
                        // multiSelectRow={onSelectedRowsChange}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default CodRemittances
